<!--
 * @Description: 查看工资条
 * @Author: fely
 * @Date: 2020-06-12 14:47:55
 * @LastEditTime: 2020-09-09 15:56:17
 * @LastEditors: fely
--> 
<template>
  <div class="view-slip">
    <div class="top-menu">
      <span>查看工资条</span>
      <span class="el-icon-close close" @click="closeMask"></span>
    </div>
    <ul class="slip-content">
      <li v-for="(item,index) in list" :key="index">
        <span>{{item.label}}</span>
        <span>{{item.value}}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    slipObj: {
      type: String,
      default(){
        return ''
      }
    },
    hiddenItem: {
      type: String,
      default(){
        return ''
      }
    },
    isshowzore: {
      type: Number,
      default(){
        return 0
      }
    },
    isshownull: {
      type: Number,
      default(){
        return 0
      }
    }
  },
  computed: {
    list(){
      if(this.slipObj){
        let arr = [], tempObj = {}
        let obj = this.slipObj.split('],[')
        let tempTitle = obj[0].substring(1,obj[0].length).split(',')
        let tempValue = obj[1].substring(0,obj[1].length-2).split(',')
        let arr2 = []   //隐藏项
        if(this.hiddenItem.indexOf(',')>=0){
          arr2 = this.hiddenItem.split(',')
        }else if(this.hiddenItem!=''){
          arr2.push(this.hiddenItem)
        }
        for (const key in tempTitle) {
          tempObj = {}
          tempObj.label = tempTitle[key]
          if(tempValue[key] !=" null")  tempObj.value = tempValue[key]
          else tempObj.value = ""
          if(tempTitle[key] != " null"){
            let tempflag = false

            // 过滤隐藏项
            tempflag = arr2.some(function(item){
              return item == tempTitle[key].trim()
            })
            // 过滤设置的 0 和 null 的显示与隐藏
            if(!tempflag){
              arr.push(tempObj)
              // if(!this.isshownull && !this.isshowzore)
              //   arr.push(tempObj)
              // else if(this.isshownull || this.isshowzore){
              //   if(this.isshownull && (tempObj.value !== '' || tempObj.value !== " null")){

              //     continue
              //   }
              //   if(this.isshowzore && tempObj.value !== ' 0'){
              //     continue
              //   }
              //   arr.push(tempObj)
              // }
            }
          }
        }
        return arr
      }else{
        return []
      }
    }
  },
  components: {},
  data() {
    return {
    }
  },
  methods: {
    closeMask(){
      this.$emit('closeMask')
    },
    
  },
}
</script>

<style scoped lang="less">
.view-slip{
  background-color: #fff;
  width: 256px;
  height: 386px;
  display: flex;
  flex-direction: column;
  .top-menu{
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px 12px 14px;
  }
  .slip-content{
    flex: 1;
    padding:20px 14px 0 14px;
    font-size: 10px;
    overflow-y: scroll;
    li{
      margin-bottom: 16px;
      line-height: 14px;
      display: flex;
      justify-content: space-between;
      span:first-child{
        color: #99A9BF;
      }
    }
  }
}
.close{
  display: inline-block;
  cursor: pointer;
}
</style>
